<template>
  <svg
    id="Duotone"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 112">
    <title>02- hand-thumbs-up-like</title>
    <g id="Icons">
      <g id="Background">
        <g
          id="New_Symbol_4-12"
          data-name="New Symbol 4">
          <circle
            class="cls-1"
            cx="50"
            cy="56"
            r="40" />
        </g>
      </g>
      <g id="Scene">
        <ellipse
          class="cls-2"
          cx="49.72"
          cy="78.28"
          rx="14"
          ry="1.5" />
        <path
          class="cls-3"
          d="M56.79,47.45c.5-5,1.16-15.77-3-15.77a3,3,0,0,0-3,3v1c0,7.38-3.2,15.1-9.4,15.1h-2V66.24h2.8c3.87,0,5.7,2.69,12.63,2.69H66.52a2.69,2.69,0,0,0,0-5.37h1.34a2.69,2.69,0,0,0,0-5.37H69.2a2.69,2.69,0,1,0,0-5.37h1.34a2.69,2.69,0,1,0,0-5.37H56.79" />
        <line
          class="cls-4"
          x1="54.1"
          y1="47.45"
          x2="58.13"
          y2="47.45" />
        <path
          class="cls-5"
          d="M56.79,47.45c.5-5,1.16-15.77-3-15.77a3,3,0,0,0-3,3v1c0,7.38-3.2,15.1-9.4,15.1h-2V66.24h2.8c3.87,0,5.7,2.69,12.63,2.69H66.52a2.69,2.69,0,0,0,0-5.37h1.34a2.69,2.69,0,0,0,0-5.37H69.2a2.69,2.69,0,1,0,0-5.37h1.34a2.69,2.69,0,1,0,0-5.37H56.79" />
        <line
          class="cls-4"
          x1="66.52"
          y1="63.56"
          x2="65.18"
          y2="63.56" />
        <line
          class="cls-4"
          x1="67.86"
          y1="58.19"
          x2="66.52"
          y2="58.19" />
        <line
          class="cls-4"
          x1="69.2"
          y1="52.82"
          x2="67.86"
          y2="52.82" />
        <rect
          class="cls-6"
          x="27.93"
          y="48.12"
          width="9.39"
          height="20.8"
          rx="1.34"
          ry="1.34" />
        <rect
          class="cls-5"
          x="27.93"
          y="48.12"
          width="9.39"
          height="20.8"
          rx="1.34"
          ry="1.34" />
        <path
          class="cls-7"
          d="M38.67,49.47h2.68a0,0,0,0,1,0,0V67.58a0,0,0,0,1,0,0H38.67a1.34,1.34,0,0,1-1.34-1.34V50.81A1.34,1.34,0,0,1,38.67,49.47Z"
          transform="translate(78.68 117.05) rotate(180)" />
      </g>
    </g>
  </svg>
</template>

<script>
  export default {};
</script>

<style lang="scss" scoped>
  @use '@/styles/variables' as *;

  .cls-1 {
    fill: var(--iconColorFaded9);
  }

  .cls-2,
  .cls-6 {
    fill: var(--iconColorFaded6);
  }

  .cls-3,
  .cls-7 {
    fill: #fff;
  }

  .cls-3,
  .cls-4,
  .cls-5,
  .cls-6,
  .cls-7 {
    stroke: var(--iconColor);

    stroke-linejoin: round;
  }

  .cls-4,
  .cls-5 {
    fill: none;
  }

  .cls-4,
  .cls-7 {
    stroke-linecap: round;
  }
</style>
